export async function getLoginData(password) {
  let data = {
    riskAdvice: 'ALLOW',
    userInfo: {
      userId: 'contact_wamr3_uat_04@sharklasers.com',
      universalID: null,
      lastLogin: '1574067336',
      previousLastLogin: null,
      passwordLastChanged: '1543301951',
      subscribedServices: 'SSOService, 251',
      universalId: 'ffffbfff965149068e7088aca99ea3e6',
      alwaysChallenge: false,
    },
  }
  switch (password) {
    case '$Testing1':
      data = {
        '@odata.context':
          'http://www-ws3.qa.columbiathreadneedleus.com/advexp.svc/$metadata#com.ameriprise.exposure.login.SSOUser/$entity',
        value: {
          riskAdvice: 'ALLOW',
          reasonCode: null,
          reason: null,
          kba: null,
          userInfo: {
            lastLogin: '1628790660',
            passwordLastChanged: '1607362186',
            previousLastLogin: null,
            subscribedServices: '251, SSOService',
            universalId: '331c450363ef996277f591b1fc2cd7eZ',
            userId: 'SalesA7NIAR@sharklasers.com',
            isAlwaysChallenge: false,
          },
          routes: null,
        },
      }
      break
  }
  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'def456',
          },
          {
            name: 'deviceid',
            value: 'deviceyourface',
          },
          {
            name: 'CSMSESSION',
            value: 'sessionyourface',
          },
        ].find((item) => param === item.name).value
      },
    },
    data: data,
    json: () => data,
  }
}

export async function getLoginDataError(password) {
  let data = {
    errorCode: '7011-2006',
    errorMessage: 'Credentials not accepted',
  }
  switch (password) {
    case 'Abcd1234!1':
      data = { errorCode: '7011-2009', errorMessage: 'SSO locked' }
      break
    case 'Abcd1234!2':
      data = { errorCode: '7011-2030', errorMessage: 'Password Expired' }
      break
    case 'Abcd1234!3':
      data = {
        userInfo: {
          userId: 'salescontact4@sharklasers.com',
          universalID: null,
          lastLogin: '1605129006',
          previousLastLogin: null,
          passwordLastChanged: '1605541298',
          subscribedServices: 'SSOService, 251',
          universalId: 'e4a8ac943386f9f78f921fce78a3daaZ',
          alwaysChallenge: false,
        },
        reasonCode: '2016',
        reason: 'Password change required',
      }
      break
  }
  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'def456',
          },
          {
            name: 'deviceid',
            value: 'deviceyourface',
          },
        ].find((item) => param === item.name).value
      },
    },
    data: data,
    json: () => data,
  }
}

export function getApiToken() {
  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'abc123',
          },
        ].find((item) => param === item.name).value
      },
    },
    data: {},
    json: () => {},
  }
}

export function getMfaResponse() {
  return {
    channel: 'EMAIL_sdFV7SB8HJ3FkM4wdvDiOg==',
  }
}

export function getMfaResponse2() {
  return {
    channel: 'KBA',
    mfa: [
      {
        qId: 'OS8Ya4ru-ahA6r0DR3wakyUlHEbmj_08ebNfzb-xtvoEgncYvE-AgT1F5JOxwWl3k48DAwqcxLwt8394-w56_uGWtYxkEaisjdQj90UhVnuWOAzQeNiCQOlpRqFH_aZ6EXYfCClOtWo',
        question: 'What was your first dogs name?',
      },
    ],
  }
}

export function getMfaAnswerResponse() {
  const data = {
    userInfo: {
      userId: 'contact_wamr3_uat_07@sharklasers.com',
      universalID: null,
      lastLogin: '1604431454',
      previousLastLogin: null,
      passwordLastChanged: '1602537497',
      subscribedServices: 'SSOService, 251',
      universalId: 'ffffbfff665343bbaa5abbaf39a5d31b',
      alwaysChallenge: false,
    },
  }
  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'def456',
          },
          {
            name: 'deviceid',
            value: 'deviceyourface',
          },
          {
            name: 'CSMSESSION',
            value: '123123123123123abcabc',
          },
        ].find((item) => param === item.name).value
      },
    },
    data: data,
    json: () => data,
    text: () => JSON.stringify(data),
    ok: true,
  }
}

export function getMfaAnswerResponseError(code) {
  let data = null
  if (!isNaN(code)) {
    if (code == '12345') {
      data = {
        errorCode: '7001-2029',
        errorMessage: 'SSO Locked',
      }
    } else {
      data = {
        errorCode: '7001-3023',
        errorMessage: 'Credentials not accepted (OTP expired)',
      }
    }
  } else {
    if (code === 'abcde') {
      data = {
        errorCode: '7001-2029',
        errorMessage: 'SSO Locked',
      }
    } else {
      data = {
        errorCode: '7001-3026',
        errorMessage: 'Credentials not accepted (MFA answer)',
      }
    }
  }
  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'ghi789',
          },
          {
            name: 'deviceid',
            value: 'deviceyourface',
          },
        ].find((item) => param === item.name).value
      },
    },
    data: data,
    json: () => data,
    text: () => JSON.stringify(data),
  }
}

export function getRiskAdviceAllow() {
  const data = { riskAdvice: 'ALLOW' }
  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'ghi789',
          },
          {
            name: 'deviceid',
            value: 'deviceyourface',
          },
        ].find((item) => param === item.name).value
      },
    },
    data: data,
    json: () => data,
    text: () => JSON.stringify(data),
  }
}

export function getRiskAdviceOTPOnly() {
  const data = {
    kba: 'false',
    riskAdvice: 'INCREASEAUTH',
    routes: {
      value: [
        {
          id: 'EMAIL_0rZKcs/LXuhbL48vOAR4/g==',
          route: 'ba*****@s******',
          channel: 'Email',
        },
      ],
    },
  }
  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'ghi789',
          },
          {
            name: 'deviceid',
            value: 'deviceyourface',
          },
        ].find((item) => param === item.name).value
      },
    },
    data: data,
    json: () => data,
    text: () => JSON.stringify(data),
  }
}

export function getChangePassword() {
  const data = {}
  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'ghi789',
          },
        ].find((item) => param === item.name).value
      },
    },
    data: data,
    json: () => data,
    text: () => JSON.stringify(data),
  }
}

export function getCreateUser() {
  const data = {
    riskAdvice: 'ALLOW',
    userInfo: {
      userId: 'Venkata.J.Ponnam@Wellsfargo.com',
      universalId: 'ghty675tgfrdy67nj8il34erfrcvnjus',
      lastLogin: '1531256882',
      previousLastLogin: '1531248254',
      passwordLastChanged: '1529701317',
      subscribedServices: 'SSOService, cmgadvweb',
      isAlwaysChallenge: false,
    },
  }

  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'abc123',
          },
        ].find((item) => param === item.name).value
      },
    },
    json: () => data,
    text: () => JSON.stringify(data),
  }
}

export function getForgotPassword(userId) {
  const data =
    userId.indexOf('error') < 0
      ? {
          reason: null,
          kba: null,
          riskAdvice: 'INCREASEAUTH',
          routes: {
            value: [
              {
                channel: 'Email',
                route: 'ba*****@s******',
                id: 'EMAIL_/R+V5Ys1WZEvNynm7R0mnA==',
              },
            ],
          },
        }
      : {
          error: {
            code: 'CTN_FORGOTPASSWORD_1114',
            description: 'System failure',
          },
        }
  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'fyptokenblah',
          },
        ].find((item) => param === item.name).value
      },
    },
    data: data,
    json: () => data,
    text: () => JSON.stringify(data),
  }
}

export function getForgotPasswordMfaAnswer() {
  const data = {
    reason: null,
    kba: null,
    riskAdvice: 'ALLOW',
    routes: {
      value: [],
    },
  }
  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'fyptokenblah',
          },
        ].find((item) => param === item.name).value
      },
    },
    data: data,
    json: () => data,
    text: () => JSON.stringify(data),
    ok: true,
  }
}

export function getForgotPasswordMfaAnswerError() {
  // const data = null
  const data = {
    error: {
      code: 'CTN_FORGOTPASSWORD_1117',
      description: 'Credentials not accepted (OTP expired)',
    },
  }
  return {
    headers: {
      get: (param) => {
        return [
          {
            name: 'apitoken',
            value: 'fyptokenblah',
          },
        ].find((item) => param === item.name).value
      },
    },
    data: data,
    json: () => data,
    text: () => null,
    ok: false,
  }
}
